import LoginView from 'legacy/modules/common/views/login';


export default function showLoginModalPopup () {
  let loginView = new LoginView();
  return new Promise(resolve => {
    loginView.execute().done(resolve);
  });
}
